import Vue from "vue";
import TwitterFeed from "vuejs-twitter-feed";

Vue.use(TwitterFeed);
